import React from 'react';
import { accountService, FormStatus, AccountForms } from '@lib/state';
import {
  useFormEvents,
  ForgotPasswordForm,
  ForgotPasswordFormFields,
  ResponsiveContainer,
} from '@lib/common';
import { Typography } from '@material-ui/core';
import { useHistory } from 'react-router-dom';

export const ForgotPasswordPage: React.FC = () => {
  const history = useHistory();

  const [{ status, error }, resetFormUI] = useFormEvents(AccountForms.ForgotPassword);

  const submit = ({ username }: ForgotPasswordFormFields) => {
    accountService.forgotPassword(username);
  };

  const onCancel = () => {
    history.push(`/account/signin`);
  };

  return (
    <ResponsiveContainer>
      <Typography
        variant="h5"
        align="center"
        color="textSecondary"
        paragraph
        data-testid="forgotPassFormTitle"
      >
        Forgot Password
      </Typography>
      <ForgotPasswordForm
        pending={status === FormStatus.Pending}
        success={status === FormStatus.Success}
        error={error}
        onSubmit={submit}
        onResetFeedback={resetFormUI}
        onCancel={onCancel}
      />
    </ResponsiveContainer>
  );
};
